var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAwardTrophy = function SvgAwardTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    vectorEffect: "non-scaling-stroke",
    width: 13.5,
    height: 4.5,
    x: 5.25,
    y: 18.75,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 1.5,
    ry: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25.75H1.773A1.023 1.023 0 0 0 .75 1.773a11.25 11.25 0 0 0 22.5 0A1.023 1.023 0 0 0 22.227.75H15.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.882 12.824 8.139 18.75h7.5l-1.576-5.916M12.6 1.075l1.248 2.458h2.127a.583.583 0 0 1 .419 1l-1.956 1.919 1.082 2.485a.589.589 0 0 1-.84.736L12.065 8.2 9.45 9.673a.589.589 0 0 1-.839-.736l1.082-2.485L7.74 4.53a.583.583 0 0 1 .42-1h2.126l1.249-2.458a.6.6 0 0 1 1.065.003"
  })));
};
export default SvgAwardTrophy;